const CSRF_TOKEN_KEY = 'authenticityToken'

// CSRF token setter/getter - caching mechanism should be hidden from consumers
export const csrf = {
  set: (token: string) => window.localStorage.setItem(CSRF_TOKEN_KEY, token),
  get: () => window.localStorage.getItem(CSRF_TOKEN_KEY),
  clear: () => window.localStorage.removeItem(CSRF_TOKEN_KEY)
}
